import useGuidesListingStore from 'layout/Listing/variants/guides/store';

const useFilterGuides = (allGuides: { data: BlogResource }[]) => {
  const search = useGuidesListingStore(state => state.search);

  if (!search) {
    return allGuides;
  }

  const searchedEvents = allGuides.filter(event => event?.data?.title?.toLowerCase().includes(search.toLowerCase()));

  return searchedEvents;
};

export default useFilterGuides;
